// Something broken?
// Use the new method instead:
//      at imports, import * as Workflow from "@ClientBase/Generic/WorkFlowStyling";
//      then, in document ready:
//      Workflow.HandleIntegratedWorkflows();

export function HandleIntegratedWorkflows() {
    const isWorkFlow = document.body.classList.contains('workflow-theme');
    if(!isWorkFlow) {
        return
    }

    const tileContainer = document?.querySelector(".workflow-widget__vacancy")! as HTMLDivElement;
    moveJobTile(tileContainer);
    updateHeadingWithJobTitle(tileContainer);
    addClickHandler(tileContainer);
}

function moveJobTile(tileContainer: HTMLElement) {
    const windowWidth = window.innerWidth;

    if (windowWidth >= 991) {
        const container = document.querySelector(
            ".workflow-container > .col-md-6:nth-of-type(1)"
        );

        if (!container) {
            return;
        }

        container.appendChild(tileContainer);
        tileContainer.style.display = "block";
    }
}

function updateHeadingWithJobTitle(tileContainer: HTMLElement): void {
    const jobTitle = tileContainer.querySelector(
        ".workflow-theme .attrax-vacancy-tile__title"
    );
    if (!jobTitle) {
        return;
    }

    const role = document.querySelector('.cust-workflow__heading .cust-workflow__role') as HTMLElement;
    if (!role) {
        return;
    }

    role.innerHTML = jobTitle.innerHTML;
}

function addClickHandler(tileContainer: HTMLElement): void {
    const jobTile = tileContainer.querySelector(
        ".attrax-vacancy-tile"
    );

    if (!jobTile) {
        return;
    }

    jobTile.addEventListener("click", function () {
        const tile = this.querySelector(
            ".attrax-vacancy-tile__title"
        ) as HTMLElement;

        if (!tile) {
            return;
        }

        const href: string | null = tile.getAttribute("href")

        if (!href) {
            return;
        }

        window.open(href, "_blank")?.focus();
    });
}
